import type { ApiError } from '@pixelworld/shared';

export type ApiResult<T> = { ok: true; data: T } | { ok: false; error: ApiError['error'] };

/**
 * Calls the PixelWorld REST API on the same origin. The session cookie goes
 * along automatically. Network failures come back as `INTERNAL_ERROR`.
 */
export async function api<T>(method: 'GET' | 'POST' | 'PUT', path: string, body?: unknown) {
  try {
    const response = await fetch(`/api/v1${path}`, {
      method,
      credentials: 'same-origin',
      headers: body === undefined ? {} : { 'content-type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
    const text = await response.text();
    const json: unknown = text ? JSON.parse(text) : null;
    if (response.ok) {
      return { ok: true, data: json as T } satisfies ApiResult<T>;
    }
    const error = (json as Partial<ApiError> | null)?.error ?? 'INTERNAL_ERROR';
    return { ok: false, error } satisfies ApiResult<T>;
  } catch {
    return { ok: false, error: 'INTERNAL_ERROR' } satisfies ApiResult<T>;
  }
}
